import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { DropdownPopover, Input, Outside, IconSearch16 } from '@cian/ui-kit';
import { useEventCallback } from '@cian/react-utils';
import { ISearchCatalogItem } from '../../../../types/geo';
import { IGeo } from '../../../../store/geo';
import { LocationSearchDropdown } from '../LocationSearchDropdown';
import * as styles from './LocationSearch.css';

export interface ILocationSearchProps {
  geo: IGeo;
  onItemSelect(suggest: ISearchCatalogItem): void;
  onTextChange(text: string): void;
}

export const LocationSearch: React.VFC<ILocationSearchProps> = ({ geo, onItemSelect, onTextChange }) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const contentRef = React.useRef<HTMLDivElement>(null);

  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadSuggests = React.useCallback(debounce(250, onTextChange), []);

  const handleValueChange = useEventCallback((_e: React.ChangeEvent<HTMLInputElement>, value: string) => {
    const query = value.trim();

    loadSuggests('');

    if (query) {
      loadSuggests(query);
    }

    setValue(value);
  });

  const handleItemSelect = useEventCallback((suggest: ISearchCatalogItem) => {
    setOpen(false);
    setValue('');

    onItemSelect(suggest);
  });

  return (
    <Outside onOutside={() => setOpen(false)} insideRefs={[inputRef, contentRef]}>
      <DropdownPopover
        open={open && !!value && !geo.isAutocompleteLoading}
        content={
          <LocationSearchDropdown
            ref={contentRef}
            list={geo.autocompleteSuggests}
            query={value.trim()}
            onSelect={handleItemSelect}
          />
        }
      >
        <Input
          ref={inputRef}
          loading={geo.isAutocompleteLoading}
          width={435}
          onChange={handleValueChange}
          value={value}
          onFocus={() => setOpen(true)}
          placeholder="Введите регион или город"
          leftAdornment={
            <div className={styles['search-icon']}>
              <IconSearch16 color="primary_100" display="block" />
            </div>
          }
        />
      </DropdownPopover>
    </Outside>
  );
};
